// eslint-disable-next-line import/prefer-default-export
export function numberWithPeriods(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
export function advancedRound(num) {
  const m = Number((Math.abs(num) * 100).toPrecision(15));
  return (Math.round(m) / 100) * Math.sign(num);
}
